import { Link } from "react-router-dom";
import { bodyBlocks, inlineTokens } from "../../lib/knowledge";

// Plain text only: React escapes everything, and the only links are https (new tab, no opener) and internal paths.
function Inline({ text }) {
  return inlineTokens(text).map((t, i) => {
    if (t.type === "external") return <a key={i} href={t.href} target="_blank" rel="noopener noreferrer" className="text-jamora hover:underline break-words">{t.text}</a>;
    if (t.type === "internal") return <Link key={i} to={t.href} className="text-jamora hover:underline">{t.text}</Link>;
    return <span key={i}>{t.text}</span>;
  });
}

export function Body({ body }) {
  return (
    <div className="space-y-2 text-sm text-slate-800 leading-relaxed">
      {bodyBlocks(body).map((b, i) => {
        if (b.type === "gap") return <div key={i} className="h-1" />;
        if (b.type === "list") return <ul key={i} className="list-disc pl-5 space-y-1">{b.items.map((item, j) => <li key={j}><Inline text={item} /></li>)}</ul>;
        return <p key={i} className="break-words"><Inline text={b.text} /></p>;
      })}
    </div>
  );
}

export function Sections({ sections }) {
  return (
    <div className="space-y-6" data-testid="article-sections">
      {sections.map((s) => (
        <section key={s.id} id={`s-${s.id}`} className="space-y-2 scroll-mt-20" data-testid={`section-${s.id}`}>
          {s.title && <h2 className="text-lg font-semibold text-slate-900">{s.title}</h2>}
          {s.body && <Body body={s.body} />}
        </section>
      ))}
    </div>
  );
}
